function saveState() {
  const map = window["map"];
  if (!map) return;
  try {
    const { lng, lat } = map.getCenter();
    localStorage.setItem(
      "mapState",
      JSON.stringify({ longitude: lng, latitude: lat, zoom: map.getZoom() })
    );
  } catch (_e) {}
}

export function defaultViewState() {
  removeEventListener("beforeunload", saveState);
  addEventListener("beforeunload", saveState);

  try {
    const initialPath = window.location.pathname.split("/");
    if (initialPath[1] === "location") {
      const initialLocation = initialPath[2].split(",");
      if (initialLocation) {
        return {
          longitude: parseFloat(initialLocation[0]),
          latitude: parseFloat(initialLocation[1]),
          zoom: 16,
        };
      }
    }
    const mapState = localStorage.getItem("mapState");
    if (mapState) return JSON.parse(mapState);
  } catch (_e) {}
  return window["CA"].defaultViewState || { longitude: 5.38711, latitude: 52.15519, zoom: 14 };
}
